import { defineComponent as _defineComponent } from 'vue'
import _ from 'lodash';
import Paginator from '@/components/common/Paginator/Paginator.vue';
import { IRolePermissions } from '@/store/modules/userRoles/types';
import { computed, watch } from 'vue';
import useStore from '@/utils/store/common';
import Modal from './components/Modal/Modal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const store = useStore();

const getUserRolesNavigationConfiguration = computed(() => store.getters['userRoles/getUserRolesNavigationConfiguration']);

const getUserRolesListState = computed(() => store.getters['userRoles/getUserRolesListState']);

const getAddition = computed(() => store.getters['userRoles/getAddition']);

const getTotalUserRoles = computed(() => store.getters['userRoles/getTotalUserRoles']);

let role: IRolePermissions | undefined;

function pageNavigationHandler(
  direction: 'forward' | 'backward'
): void {
  store.dispatch('userRoles/userRolesListNavigation', {
    direction
  });
}

function getCurrentUserIsAbleToWrite(featureName: string) {
  return featureName ? store.getters['permissions/getCurrentUserIsAbleTo']('write', featureName) : false;
}

function handleAdd() {
  store.dispatch('userRoles/setEdition', false);
  store.dispatch('userRoles/setAddition', true);
  role = _.cloneDeep(store.getters['userRoles/getCurrentUserRole']);

  store.dispatch('userRoles/resetPermissionsOfRole');
}

function handleCancel() {
  if (role && role.id) {
    store.dispatch('userRoles/fetchPermissionsOfRole', role.id);
  }
  store.dispatch('userRoles/setAddition', false);
}

function navigateToPage(page: number) {
  const current = getUserRolesNavigationConfiguration.value;
  const next = {
    ...current,
    start: page * current.elementsPerPage - current.elementsPerPage
  };
  store.dispatch('userRoles/updateNavigation', next);
}

watch(
  () => getUserRolesNavigationConfiguration.value.start,
  async () => {
    await store.dispatch('userRoles/fetchPermissionsRoles', getUserRolesNavigationConfiguration.value);
  },
  {
    immediate: true
  }
);


return { __sfc: true,store, getUserRolesNavigationConfiguration, getUserRolesListState, getAddition, getTotalUserRoles, role, pageNavigationHandler, getCurrentUserIsAbleToWrite, handleAdd, handleCancel, navigateToPage, Paginator, Modal }
}

})